module.exports = __webpack_public_path__ + "static/media/cardOne.188b0a8b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Images/rowSix/cardOne.jpg
// module id = 83
// module chunks = 0